if (typeof globalThis !== "undefined") {
  if (typeof globalThis.TextEncoder === "undefined") {
    class SimpleTextEncoder {
      encode(input = "") {
        const text = String(input);
        const bytes = [];
        for (let i = 0; i < text.length; i += 1) {
          const code = text.charCodeAt(i);
          if (code < 0x80) {
            bytes.push(code);
          } else if (code < 0x800) {
            bytes.push(0xc0 | (code >> 6));
            bytes.push(0x80 | (code & 0x3f));
          } else {
            bytes.push(0xe0 | (code >> 12));
            bytes.push(0x80 | ((code >> 6) & 0x3f));
            bytes.push(0x80 | (code & 0x3f));
          }
        }
        return new Uint8Array(bytes);
      }
    }

    globalThis.TextEncoder = SimpleTextEncoder;
  }

  if (typeof globalThis.TextDecoder === "undefined") {
    class SimpleTextDecoder {
      decode(input = new Uint8Array()) {
        return Array.from(input)
          .map((byte) => String.fromCharCode(byte))
          .join("");
      }
    }

    globalThis.TextDecoder = SimpleTextDecoder;
  }

  const fetchGlobals = ["fetch", "Headers", "Request", "Response"];
  fetchGlobals.forEach((key) => {
    if (typeof globalThis[key] === "undefined" && typeof window !== "undefined" && window[key]) {
      globalThis[key] = window[key];
    }
  });
}
